import React, { useContext, useState } from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";

import useStyles from "./useStyles";
import { useShoppingCart, useAppSetting, useLayout } from "../../hooks";
import { LanguageContext, MenuContext, CartContext } from "../../contexts";
import HistoryOrderCtx from "../../contexts/history-order.context";
import PaymentCtx from "../../contexts/Payment.context";

import ShoppingCartOverlay from "../ShoppingCartOverlay/ShoppingCartOverlay";
import PaymentLoading from "../PaymentLoading/PaymentLoading.component";

import { withRouter, useParams } from "react-router";
import strings from "../../strings";

import PaymentCover from "../../components/PaymentCover/PaymentCover.component"
import { checkIsMiniProgram } from "../../utils/miniapp";
// import CartList from "../../pages/ConfirmPage/CartList";
import {getOrderType} from "../../utils/index"
const ShoppingCartButton = ({ history }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [showPaymentLoading, setShowPaymentLoading] = useState(false);
  const { tableCode } = useParams();
  const [state] = useContext(LanguageContext);
  const [menuState] = useContext(MenuContext);
  //Test
  const [cartState, cartDispatch] = useContext(CartContext);

  const [historyOrderState] = useContext(HistoryOrderCtx.Context);
  const [, paymentDispatch] = useContext(PaymentCtx.Context);
  const { historyOrder } = historyOrderState;
  const { isCn } = state;
  const {
    totalQuantity,
    totalAmount,
    toggleCartOverlay,
    isShowCartOverlay,
    getPaymentUrl,
  } = useShoppingCart();
  const { showOptionModal } = menuState;
  const { needPay } = useAppSetting();
  const { uiSuite } = useLayout();

  const [paymentOpen, setPaymentOpen] = useState(false);
  const handlePaymentClose = ()=>{
    setPaymentOpen(false)
  }


  const getChannel = () => {
    const ua = window.navigator.userAgent.toLowerCase();
    const isWechat = ua.match(/MicroMessenger/i) == "micromessenger";
    return isWechat ? "WECHAT" : "ALIPAY";
  };

  const navToConfirm = async () => {
    
    // const hostnameArray = window.location.hostname.split(".");
    // if (hostnameArray[1] === "preorder") {
    if (getOrderType() === "preorder") {
      if (needPay) {
        setShowPaymentLoading(true);
        const resp = await getPaymentUrl(getChannel());
        setShowPaymentLoading(false);
        if (resp.status === "success") {
          if (resp.approvel_url !== "") {
            window.location.href = resp.approvel_url;
          } else {
            paymentDispatch({
              type: PaymentCtx.ActionTypes.update,
              payload: { payform: JSON.parse(resp.message).data.payForm },
            });
            history.push(`${process.env.PUBLIC_URL}/payform/alipay`);
          }
        } else {
          alert(resp.message);
        }
      } else {
        history.push(`${process.env.PUBLIC_URL}/confirm/preorder`);
      }
    } else {
      if (totalQuantity > 0) {
        history.push(`${process.env.PUBLIC_URL}/confirm/${tableCode}`);
        return;
      }
      if (
        historyOrder.salesorderLines === undefined ||
        historyOrder.salesorderLines.length === undefined ||
        historyOrder.salesorderLines.length <= 0
      )
        return;
      history.push(`${process.env.PUBLIC_URL}/confirm/${tableCode}`);
    }
  };

  // if (totalQuantity === 0) return null
  const isNotPreorder = () => {
    // const domainArray = window.location.hostname.split(".");

    return (
      getOrderType() !== "preorder" &&
      window.location.hostname !== "preorder.xiyantong.pw"
    );
  };

  const getByLabelText = () => {
    if (isShowCartOverlay && !isNotPreorder() && needPay) {
      return strings.makePayment;
    } else if (isShowCartOverlay) {
      return strings.shoppingCartButtonLabel;
    } else {
      return strings.view;
    }
  };

  if (showOptionModal) return null;
  if (uiSuite === "CHOWBUS" && totalQuantity <= 0) return null;

  return (
    <>
      {isShowCartOverlay && (
        <ShoppingCartOverlay toggleCartOverlay={toggleCartOverlay} />
      )}
      {showPaymentLoading && <PaymentLoading channel={getChannel()} />}
      <div
        className={
          uiSuite === "CHOWBUS" ? classes.containerChow : classes.container
        }
        onClick={() => {
          console.log("shopping cart button menustate", menuState)
          console.log("shopping cart button cartState",cartState)
          if (!isNotPreorder() && totalQuantity <= 0) {
            return;
          }

          if (isNotPreorder() && totalQuantity <= 0) {
            navToConfirm();
            return;
          }

          if (!isShowCartOverlay && totalQuantity > 0) {
            toggleCartOverlay();
            return;
          }

          if (isShowCartOverlay && totalQuantity > 0) {

            if(checkIsMiniProgram() && getOrderType() === "preorder"){
              setPaymentOpen(true)
              return
            }
            navToConfirm();
            return;
          }
        }}
      >
        <div
          className={classes.cartIconContainer}
          onClick={(e) => {
            if (totalQuantity > 0) {
              e.stopPropagation();
              toggleCartOverlay();
            }
          }}
        >
          {/* <img src={cartIcon} alt="" className={classes.cartIcon} /> */}
          <svg
            width="36px"
            fill={theme.colors.main}
            height="36px"
            viewBox="0 0 36 36"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <title>购物车</title>
            <desc>Created with Sketch.</desc>
            <defs>
              <linearGradient
                x1="31.4465615%"
                y1="15.9711264%"
                x2="68.103157%"
                y2="69.4238545%"
                id="linearGradient-1"
              >
                <stop stopColor="#FFD05E" offset="0%"></stop>
                <stop stopColor="#FFC131" offset="100%"></stop>
              </linearGradient>
            </defs>
            <g
              id="C端"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g id="menu修改" transform="translate(-48.000000, -760.000000)">
                <g
                  id="Button-/-Active"
                  transform="translate(32.000000, 753.000000)"
                >
                  <g id="购物车" transform="translate(16.000000, 7.000000)">
                    <circle
                      id="椭圆形"
                      fill="#FFFFFF"
                      cx="18"
                      cy="18"
                      r="18"
                    ></circle>
                    <path
                      d="M13.5,23 C13.8405027,23 14.1630833,23.063063 14.4677419,23.1891892 C14.7724006,23.3153154 15.0412178,23.4909919 15.2741935,23.7162162 C15.5071685,23.9414414 15.6863791,24.2072081 15.811828,24.5135135 C15.9372761,24.8198189 16,25.1441433 16,25.4864865 C16,25.8288297 15.9372761,26.153154 15.811828,26.4594595 C15.6863798,26.7657649 15.5071693,27.0315324 15.2741935,27.2567568 C15.0412186,27.4819819 14.7724006,27.6621622 14.4677419,27.7972973 C14.1630833,27.9324324 13.8405027,28 13.5,28 C13.1415779,28 12.8145161,27.9324324 12.5188172,27.7972973 C12.2231183,27.6621622 11.9587822,27.4819811 11.7258065,27.2567568 C11.4928315,27.0315316 11.3136209,26.7657649 11.188172,26.4594595 C11.0627239,26.153154 11,25.8288297 11,25.4864865 C11,25.1441433 11.0627239,24.8198189 11.188172,24.5135135 C11.3136202,24.2072081 11.4928307,23.9414406 11.7258065,23.7162162 C11.9587814,23.4909911 12.2231183,23.3153162 12.5188172,23.1891892 C12.8145161,23.063063 13.1415779,23 13.5,23 L13.5,23 Z M22.486631,23 C22.8253128,23 23.150623,23.063063 23.4625668,23.1891892 C23.7745107,23.3153154 24.0418904,23.4909919 24.2647059,23.7162162 C24.4875222,23.9414414 24.6657754,24.2072081 24.7994652,24.5135135 C24.9331551,24.8198189 25,25.1441433 25,25.4864865 C25,25.8288297 24.9331551,26.153154 24.7994652,26.4594595 C24.6657754,26.7657649 24.4875214,27.0315324 24.2647059,27.2567568 C24.0418896,27.4819819 23.7745107,27.6621622 23.4625668,27.7972973 C23.150623,27.9324324 22.8253128,28 22.486631,28 C22.1479492,28 21.8270936,27.9324324 21.5240642,27.7972973 C21.2210347,27.6621622 20.9581096,27.4819811 20.7352941,27.2567568 C20.5124778,27.0315316 20.3342246,26.7657649 20.2005348,26.4594595 C20.0668449,26.153154 20,25.8288297 20,25.4864865 C20,25.1441433 20.0668449,24.8198189 20.2005348,24.5135135 C20.3342246,24.2072081 20.5124786,23.9414406 20.7352941,23.7162162 C20.9581104,23.4909911 21.2210347,23.3153162 21.5240642,23.1891892 C21.8270936,23.063063 22.1479492,23 22.486631,23 Z M26.4047352,12 C26.8210074,12 27.1443611,12.0510204 27.3747964,12.1530612 C27.6052316,12.255102 27.7687683,12.380953 27.865402,12.5306122 C27.9620364,12.680272 28.0066369,12.8401367 27.9992036,13.0102041 C27.9917702,13.180272 27.9657532,13.3265306 27.9211527,13.4489796 C27.8765522,13.5714286 27.7836344,13.8231286 27.6423995,14.2040816 C27.5011646,14.5850347 27.341346,15.003402 27.1629439,15.4591837 C26.9845419,15.9149653 26.8098573,16.3673469 26.6388879,16.8163265 C26.4679192,17.2653061 26.3378344,17.619047 26.2486334,17.877551 C26.0553644,18.4217694 25.810061,18.7993204 25.5127249,19.0102041 C25.2153889,19.2210878 24.8511499,19.3265306 24.4200123,19.3265306 L23.6618036,19.3265306 L22.2122869,19.3265306 L20.316765,19.3265306 L18.2428411,19.3265306 L12.7123774,19.3265306 L13.0468812,21.1632653 L24.2862108,21.1632653 C24.999819,21.1632653 25.3566231,21.4421775 25.3566231,22 C25.3566231,22.2721082 25.2860056,22.5068021 25.1447707,22.7040816 C25.0035358,22.9013606 24.7247832,23 24.308511,23 L23.2380987,23 L21.1641748,23 L18.5996452,23 L15.9905152,23 L13.8496905,23 L12.6231763,23 C12.3258403,23 12.07682,22.9387755 11.8761177,22.8163265 C11.6754154,22.6938776 11.5081635,22.5340143 11.3743619,22.3367347 C11.2405604,22.1394557 11.1327766,21.9251694 11.0510082,21.6938776 C10.9692405,21.4625857 10.9060566,21.244898 10.861456,21.0408163 C10.8465892,20.9591837 10.8057054,20.7619041 10.7388046,20.4489796 C10.6719039,20.1360551 10.5901362,19.744898 10.4935018,19.2755102 C10.3968674,18.8061224 10.2890827,18.2823123 10.1701481,17.7040816 C10.0512134,17.125851 9.93227793,16.5442184 9.81334396,15.9591837 C9.53087331,14.5850347 9.21123701,13.0544284 8.8544329,11.3673469 L7.18191362,11.3673469 C6.95891105,11.3673469 6.7730763,11.3163265 6.6244072,11.2142857 C6.47573874,11.1122449 6.35308668,10.9897959 6.25645296,10.8469388 C6.15981858,10.7040816 6.09291781,10.5510204 6.05575064,10.3877551 C6.01858347,10.2244898 6,10.0748306 6,9.93877551 C6,9.66666733 6.10035116,9.44217754 6.30105347,9.26530612 C6.50175578,9.08843531 6.7730763,9 7.11501285,9 L7.60561851,9 L8.05162365,9 L8.60913007,9 L9.36733881,9 C9.66467485,9 9.90254498,9.04081633 10.080947,9.12244898 C10.2593491,9.20408163 10.4005833,9.30612245 10.5046519,9.42857143 C10.6087199,9.55102041 10.683054,9.68027144 10.7276545,9.81632653 C10.772255,9.95238102 10.8094222,10.0680265 10.8391558,10.1632653 C10.8688894,10.2721088 10.8986232,10.4251694 10.9283568,10.622449 C10.9580904,10.819728 10.9878242,11.0204082 11.0175578,11.2244898 C11.0621583,11.4693878 11.1067589,11.7278918 11.1513594,12 L26.4047352,12 L26.4047352,12 Z"
                      id="形状"
                      fill={theme.colors.main}
                      fillRule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          {totalQuantity > 0 && (
            <div className={classes.quantity}>{totalQuantity}</div>
          )}
        </div>
        <div
          className={classnames(classes.label, { active: totalQuantity > 0 })}
          style={{ fontFamily: isCn ? "Pingfang" : "sans-serif" }}
        >
          {getByLabelText()}
        </div>

        {totalAmount > 0 && (
          <div className={classes.amount}>
            {totalQuantity > 0 && `$ ${totalAmount}`}
          </div>
        )}
      </div>
      <PaymentCover open={paymentOpen} onClose={handlePaymentClose}/>
    </>
  );
};

export default withRouter(ShoppingCartButton);
